import axios from "axios"
import {getAllUpcomingReservations, getHeader, getPatientHistory} from "../../config";
import {types} from "../types/globalTypes";
import {reservationTypes} from "../types/reservationTypes";

export const getUpcomingReservations = () => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getAllUpcomingReservations, {}, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                dispatch({
                    type: reservationTypes.GET_UPCOMING_RESERVATIONS,
                    payload: res.data.Response
                });
            } else {
                dispatch({
                    type: reservationTypes.UPCOMING_RESERVATIONS_NOT_FOUND,
                    payload: true,
                })
            }

        }).catch(error => {
            console.log(error);
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        })
    }
}
export const getPastReservations = (limit, offset) => {
    let data = {
        limit: limit,
        offset: offset
    }
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        dispatch({
            type: reservationTypes.FETCHING_MORE_PAST_RESERVATIONS,
            payload: true
        });
        axios.post(getPatientHistory, data, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                dispatch({
                    type: reservationTypes.GET_PAST_RESERVATIONS,
                    payload: res.data.Response
                });
                dispatch({
                    type: reservationTypes.FETCHING_MORE_PAST_RESERVATIONS,
                    payload: false
                });
                if (res.data.Response.length < limit){
                    dispatch({
                        type: reservationTypes.NO_MORE_PAST_RESERVATIONS,
                        payload: true
                    });
                }
            }
            /*else {
                dispatch({
                    type: "PAST_RESERVATIONS_NOT_FOUND",
                    payload: true,
                })
            }*/

        }).catch(error => {
            console.log(error);
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        })
    }
}
export const removeReservationFromList = (deleted) => {
    return (dispatch, getState) => {
        const {upcomingReservations} = getState().reservation;
        const newList = upcomingReservations.filter(reservation => {
            return deleted.id !== reservation.id
        });
        dispatch({
            type: reservationTypes.GET_UPCOMING_RESERVATIONS,
            payload: newList
        })
    }
};
export const clearPastReservations = () => {
    return (dispatch) => {
        dispatch({
            type: reservationTypes.CLEAR_PAST_RESERVATIONS,
            payload: null,
        })
    }
};
export const clearUpcomingReservations = () => {
    return (dispatch) => {
        dispatch({
            type: reservationTypes.CLEAR_UPCOMING_RESERVATIONS,
            payload: null,
        })
    }
};
export const changeAuthPopUpStatus = (status) => {
    return (dispatch) => {
        dispatch({
            type: reservationTypes.CHANGE_AUTH_POP_UP_STATUS,
            payload: status,
        })
    }
};
export const changeActivationPopUpStatus = (status) => {
    return (dispatch) => {
        dispatch({
            type: reservationTypes.CHANGE_ACTIVATION_POP_UP_STATUS,
            payload: status,
        })
    }
};